import { TabOption } from 'src/components/primitives/Tabs/types';
import { HistoryType } from 'src/@types/historyTables';

export const PORTFOLIO_HISTORY_TABS: TabOption<HistoryType>[] = [
	{
		value: 'deposits',
		label: 'Balances',
	},
	{
		value: 'orders',
		label: 'Orders',
	},
	{
		value: 'trades',
		label: 'Trades',
	},
	{
		value: 'positions',
		label: 'Positions',
	},
	{
		value: 'funding-payments',
		label: 'Funding',
	},
	{
		value: 'rewards',
		label: 'Rewards',
	},
	{
		value: 'liquidations',
		label: 'Liquidations',
	},
	{
		value: 'if-staking',
		label: 'IF Staking',
	},
	{
		value: 'settled-balances',
		label: 'Settled',
	},
	{
		value: 'exports',
		label: 'Exports',
	},
];

export const PORTFOLIO_HISTORY_TABS_VALUES = PORTFOLIO_HISTORY_TABS.map(
	(tab) => tab.value
);

export const PORTFOLIO_HISTORY_DEFAULT_TAB = PORTFOLIO_HISTORY_TABS[0].value;

export const PORTFOLIO_HISTORY_MARKET_FILTER_ALL_OPTION = {
	mint: 'all_markets',
	ticker: 'all_markets',
	displayLabel: 'All Markets',
	marketIndex: -1,
};

export const PORTFOLIO_HISTORY_TABLE_EMPTY_CLASSNAME = 'h-80';
